import { useState, useEffect } from 'react';
import MetaTagFixer, { MetaTagStatus } from '../utils/metaTagFixer';

export const useMetaTagFixer = () => {
  const [status, setStatus] = useState<MetaTagStatus>({
    deprecated: [],
    correct: [],
    missing: [],
    fixed: false
  });
  const [isFixing, setIsFixing] = useState(false);

  const checkStatus = () => {
    const currentStatus = MetaTagFixer.checkStatus();
    setStatus(currentStatus);
    return currentStatus;
  };

  const fixMetaTags = async () => {
    setIsFixing(true);
    try {
      const result = MetaTagFixer.fix();
      setStatus(result);
      return result;
    } catch (error) {
      console.error('Erro ao corrigir meta tags:', error);
      return status;
    } finally {
      setIsFixing(false);
    }
  };

  const autoFix = async () => {
    setIsFixing(true);
    try {
      const result = MetaTagFixer.autoFix();
      setStatus(result);
      return result;
    } catch (error) {
      console.error('Erro na correção automática:', error);
      return status;
    } finally {
      setIsFixing(false);
    }
  };

  useEffect(() => {
    // Verificar status inicial
    checkStatus();

    // Configurar observer para mudanças no DOM
    const observer = new MutationObserver(() => {
      checkStatus();
    });

    observer.observe(document.head, {
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return {
    status,
    isFixing,
    checkStatus,
    fixMetaTags,
    autoFix,
    hasIssues: MetaTagFixer.hasIssues(),
    getStatusMessage: MetaTagFixer.getStatusMessage()
  };
}; 